import { CheckIcon } from "@radix-ui/react-icons"; // Or your preferred check icon
import clsx from "clsx";
import { Checkbox as CheckboxPrimitive } from "radix-ui";
import React from "react";
import styles from "./checkbox.module.scss";

export interface CheckboxProps
  extends React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> {
  label?: string;
  id?: string;
}

export const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  CheckboxProps
>(({ className, label, id: idProp, ...props }, ref) => {
  const generatedId = React.useId();
  const checkboxId = idProp || generatedId;

  return (
    <div className={styles.container}>
      <CheckboxPrimitive.Root
        ref={ref}
        className={clsx(styles.root, className)}
        id={checkboxId}
        {...props}
      >
        <CheckboxPrimitive.Indicator className={styles.indicator}>
          <CheckIcon />
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
      {label && (
        <label htmlFor={checkboxId} className={styles.label}>
          {label}
        </label>
      )}
    </div>
  );
});

Checkbox.displayName = CheckboxPrimitive.Root.displayName;
